// docs: https://github.com/altostra/type-validations#readme
import { objectOf, arrayOf } from "@altostra/type-validations";
import { string, boolean } from "@altostra/type-validations/lib/primitives";

export const isEngagementApiSuppressionListsSettingsResult = objectOf({
  suppression_lists: arrayOf(
    objectOf({
      id: string,
      name: string,
      enabled: boolean,
      exception_tags: arrayOf(
        objectOf({
          id: string,
          name: string,
        })
      ),
    })
  ),
});
